// @ts-ignore
import mpath from "mpath";

const configuration = {};

export const load = (config: object) => Object.assign(configuration, config);

export const get = (path: string = "", defaultValue: any = undefined) => {
    return mpath.get(path, configuration) ?? defaultValue;
};

export const set = (path: string, value: any) => (configuration as any)[path] = value;
